
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { TerraceSubmission } from '@/types';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  submission: TerraceSubmission | null;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteConfirmationDialog = ({
  isOpen,
  onOpenChange,
  submission,
  onConfirm,
  isDeleting
}: DeleteConfirmationDialogProps) => {
  if (!submission) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Submission</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Are you sure you want to delete the submission for <strong>"{submission.name}"</strong>?
            </p>
            <p className="text-sm text-muted-foreground">
              This will permanently remove:
            </p>
            <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1">
              <li>The submission record</li>
              {submission.status === 'approved' && (
                <>
                  <li>The published terrace (if it exists)</li>
                  <li>All user favorites for this terrace</li>
                  <li>All viewing history for this terrace</li>
                </>
              )}
              <li>All API logs related to this submission</li>
            </ul>
            <p className="text-sm font-medium text-red-600">
              This action cannot be undone.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? "Deleting..." : "Delete Submission"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmationDialog;
